exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backtest-Tabs-PnlByTicker-___controls__wrapper___KsnOw{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.src-components-Backtest-Tabs-PnlByTicker-___controls__search___1QQ9L{max-width:150px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Backtest-Tabs-PnlByTicker-___controls__wrapper___KsnOw",
	"search": "src-components-Backtest-Tabs-PnlByTicker-___controls__search___1QQ9L"
};